import styled from 'styled-components';

export const Container = styled.div`
  /* TODO: Agregar estilos de los mensajes del chat */
`;
